import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

const ReverseProposalStatusSchema = z.enum(['WAITING', 'APPROVED', 'REJECTED']);
const ReverseProposalSortSchema = z.enum(['LATEST', 'BRAND_NAME']);

const GetReverseProposalsRequestSchema = z
  .object({
    status: ReverseProposalStatusSchema.optional(),
    sort: ReverseProposalSortSchema.optional(),
    page: z.number().min(1).optional(),
    size: z.number().min(1).max(100).optional(),
  })
  .describe('GetReverseProposalsRequestSchema');

export type GetReverseProposalsRequest = z.infer<typeof GetReverseProposalsRequestSchema>;

const ReverseProposalItemSchema = z
  .object({
    id: z.number(),
    status: ReverseProposalStatusSchema,
    brandImageUrl: z.string(),
    brandId: z.string(),
    brandName: z.string(),
    message: z.string(),
    createdAt: z.string(),
    startAt: z.string(),
    campaignProposalId: z.number().nullable().optional(),
  })
  .describe('ReverseProposalItemSchema');

const GetReverseProposalsResponseDataSchema = z.object({
  list: z.array(ReverseProposalItemSchema),
});

const GetReverseProposalsResponseSchema = createApiResponseSchema(
  GetReverseProposalsResponseDataSchema,
);

export type GetReverseProposalsResponse = z.infer<typeof GetReverseProposalsResponseSchema>;

export const getReverseProposals = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetReverseProposalsRequestSchema),
    async (params: GetReverseProposalsRequest): Promise<GetReverseProposalsResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.get<GetReverseProposalsResponse>(
          urlJoin(campaignsApiPath.getReverseProposals),
          params,
        );
        return response;
      }),
    validateApiResponse(GetReverseProposalsResponseSchema),
  ),
);
